

































	import { Instance } from '@/classes/TayehApi';
import ImageView from '@/components/ImageView.vue';
import { SrcFilter } from '@/mixins/Media';
import {
		Component,
		Prop,
		Vue,
    Watch
	} from 'vue-property-decorator';
	import {
		mapGetters
	} from 'vuex'

	@Component({
  components: { ImageView },
		computed: {
			...mapGetters(['update_inventory'])
		},
		mixins: [
			SrcFilter
		]
	})
	export default class ShopInventoryBrandsTable extends Vue {
		@Prop() private readonly instanceId: number;
		@Prop() private readonly parent_id: number;
		@Prop() private readonly editable: number;
		private brands: any[] = [];
		private loading = false;
		private search = '';


		@Watch('update_inventory')
		async get() {
			this.loading = true;
			try {
				this.brands = (await Instance.getBrands(this.instanceId, {search: this.search})).data;
			} catch (err) {
				console.log(err);
			} finally {
				this.loading = false;
			}
		}
		async askForDelete(brands: any) {
			try {
				await this.$confirm(`آیا میخواهید برند "${brands.name}" را حذف کنید؟`, {
					title: 'حذف برند',
					confirmButtonText: 'بله',
					cancelButtonText: 'خیر'
				})
				this.deleteBrand(brands.id);
			} catch (err) {
				return;
			}
		}
		async deleteBrand(id: string) {
			this.loading = true;
			try {
				await Instance.deleteBrand(this.instanceId, id);
				this.$message({
					showClose: true,
					message: 'برند با موفقیت حذف شد.',
					type: 'success',
					duration: 5000
				});
				this.get()
			} catch (err) {
				console.log(err);
			} finally {
				this.loading = false;
			}
		}

		mounted() {
			this.get();
		}
	}
